<mat-tab-group mat-stretch-tabs [dynamicHeight]="true">
  <mat-tab label="PROFILE">
    <br />
    <div *ngIf="(hasValidToken$ | async); else noValidToken">
      <div *ngIf="(decodedToken$ | async) as decodedToken">
        <div mat-dialog-title>
          <div fxLayout="row" fxLayoutAlign="center center">
            <ngx-avatar [@rotatedState]='state' [name]="decodedToken?.firstName + ' ' + decodedToken?.surname" size="100"
              textSizeRatio="2"></ngx-avatar>
          </div>
        </div>
        <div mat-dialog-content>
          <div fxLayout="column" fxLayoutAlign="center center">
            <p>{{ decodedToken.firstName }} {{ decodedToken.surname }}</p>
            <p style="max-width:500px; text-align: center;">Roles: {{ decodedToken.roles.join(', ') }}</p>
            <p>Access expires {{ decodedToken.expires | amTimeAgo }}.</p>
          </div>
        </div>
      </div>
      <div mat-dialog-actions align="center">
        <button (click)="logout()" mat-button>LOGOUT</button>
        <button mat-button (click)="close()">CLOSE</button>
      </div>
    </div>
    <ng-template #noValidToken>
      <app-login (loginClicked)="login($event)" (forgotPasswordClicked)="forgotPassword()" (clearLastUserClicked)="clearLastUser()"
        [lastLoggedInUser]="lastLoggedInUser$ | async" [isLoading]="isLoading$ | async"></app-login>
    </ng-template>
    <br />
  </mat-tab>
  <mat-tab label="SETTINGS">
    <br />
    <app-theme-switcher [theme]="theme$ | async" (selectThemeClicked)="selectTheme($event)" (closeClicked)="close()"></app-theme-switcher>
    <br />
  </mat-tab>
</mat-tab-group>
